jQuery(document).ready(function ($) {
  $(document).on("click", ".edit-comment-btn", function (e) {
    e.preventDefault();
    let commentID = $(this).data("id");
    let currentContent = $(this).data("content");

    Swal.fire({
      title: wooloyaltyL10n.edit_title,
      input: "textarea",
      inputValue: currentContent,
      showCancelButton: true,
      confirmButtonText: wooloyaltyL10n.save_button,
      cancelButtonText: wooloyaltyL10n.cancel_button,
      customClass: {
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },

      preConfirm: (newContent) => {
        if (!newContent) {
          Swal.showValidationMessage(wooloyaltyL10n.empty_comment);
        }
        return newContent;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        $("#comment-content-" + commentID).val(result.value);
        $("#edit-comment-form-" + commentID).submit();
      }
    });
  });

  $(document).on("click", ".delete-comment-btn", function (e) {
    e.preventDefault();
    let deleteUrl = $(this).data("url");
    let currentContent = $(this).data("content");

    Swal.fire({
      title: wooloyaltyL10n.delete_confirm_title,
      text: `${wooloyaltyL10n.delete_confirm_text} "${currentContent}" ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: wooloyaltyL10n.delete_success,
      cancelButtonText: wooloyaltyL10n.cancel_button,
      customClass: {
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = deleteUrl;
      }
    });
  });
});
